import React from 'react'
import { Members } from '../../component/about/Members'

export default function MembersPage() {
  return (
    <>
      <Members />
    </>
  )
}
